import { Avatar, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { SmallCheckmark, TrashCanBlackSmall, View } from 'Images';

interface IFile {
  file: File;
  setFile: (file: File | null) => void;
}

export const File = ({ file, setFile }: IFile) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);

  return (
    <Stack
      sx={{
        gap: '16px',
        mt: isDesktop ? undefined : '16px',
        maxWidth: isDesktop ? undefined : '100%',
      }}
    >
      <Typography variant={isDesktop ? 'body2' : 'body5'}>
        {dictionary.file}
      </Typography>
      <Stack
        sx={{
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          gap: '8px',
          p: '12px 16px',
          flexDirection: 'row',
          alignItems: 'center',
          bgcolor: 'white',
        }}
      >
        <Avatar
          alt=''
          src={SmallCheckmark}
          sx={{ width: '32px', height: '32px' }}
        />
        <Typography sx={{ wordBreak: 'break-word' }} variant='body1'>
          {file.name}
        </Typography>
      </Stack>
      <Stack direction={'row'} justifyContent={'end'}>
        <Button
          sx={{
            alignSelf: 'flex-end',
            color: 'black',
            gap: '4px',
          }}
          onClick={() => setFile(null)}
        >
          <Avatar
            alt=''
            src={TrashCanBlackSmall}
            sx={{ width: '24px', height: '24px' }}
          />
          <Typography variant='body5'>{dictionary.delete}</Typography>
        </Button>
        <Button
          sx={{
            alignSelf: 'flex-end',
            color: 'black',
            gap: '4px',
          }}
          onClick={() => window.open(URL.createObjectURL(file))}
        >
          <Avatar alt='' src={View} sx={{ width: '24px', height: '24px' }} />
          <Typography variant='body5'>{dictionary.view}</Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
